import {
  buildCartItemsList, buildProductList,
} from "./adobeCart";

import {sendAdobeEvent} from "./adobeAnalyticsHelpers";
import {pick} from "lodash";

/**
 * Send an addToCart event to Adobe analytics.
 * The shopping cart and its items are adapted to Adobe's field name conventions.
 *
 * @param cartItems
 * @param shoppingCart
 * @returns {{eventInfo: (*|{})}}
 */
export function sendAddToCartEvent({
  shoppingCart, items
}) {
  const event = buildAdobeCartEvent({
    shoppingCart,
    eventInfo: {
      eventName: "addToCart",
      type: "cart add"
    },
    withProductList: items
  })

  sendAdobeEvent(event);

  return event;
}

export function sendRemoveFromCartEvent({
  items, // the newly removed item(s),
  cartItems,
  shoppingCart,
}) {
  const event = buildAdobeCartEvent({
    shoppingCart, cartItems,
    eventInfo: {
      eventName: "removeFromCart",
      type: "cart remove"
    },
    withProductList: items
  })

  // field name is singular but it wants a list
  event.product = simplifyProductList(event.product);

  return sendAdobeEvent(event);
}

export function sendViewCartEvent({
  shoppingCart, cartItems,
}) {

  const event = buildAdobeCartEvent({
    shoppingCart,
    cartItems,
    eventInfo: {
      eventName: "NOLACartView",
      type: "cart view"
    },
    withCartItems: cartItems
  });

  // if (isDev) {
  //   alert("send adobe event: " + JSON.stringify(eventInfo, null, 2));
  // }

  return sendAdobeEvent(event);
}

export function sendStartCheckoutEvent({
  shoppingCart, cartItems,
}) {
  cartItems ||= shoppingCart.cartItems;

  const event = buildAdobeCartEvent({
    shoppingCart, eventInfo: {
      eventName: "Cartcheckoutstart",
      // type: "cart view"
    },
    withProductList: cartItems
  });

  return sendAdobeEvent(event);
}

export function buildAdobeCartEvent({
  shoppingCart,
  eventInfo = {},
  withProductList = null,
  withCartItems = null,
  event = {}
}) {
  eventInfo = Object.assign({}, eventInfo); // clone it.

  //eventInfo.type ||= "cart view";
  eventInfo.eventName ||= "NOLACartView";
  eventInfo.timeStamp ||= new Date().toISOString();
  eventInfo.processed ||= {adobeAnalytics: false};

  event = Object.assign({eventInfo}, event);

  if (withCartItems && withCartItems.map) {
    event.Cart ||= {}
    event.Cart.item = buildCartItemsList({items: withCartItems, shoppingCart})
  }

  if (withProductList && withProductList.map) {
    event.product = buildProductList({items: withProductList, shoppingCart});
  }

  return event;
}


function simplifyProductList(list) {
  if (list && list.map) {
    list = list.map(item => {
      item.productInfo = simplifyProductInfo(item.productInfo);
      return item;
    });
  }
  return list;
}

// Discard unwanted fields from an Adobe "product" object.
function simplifyProductInfo(productInfo) {
  return pick(productInfo,
    "productID", "currency", "cartId", "sellingPrice",
    "quantity", "fulfillmentMethod",
    "productHQID", "searchPlatform")
}
